import PreviewContainer from '@bingads-webui-campaign-legacy/crud-ad/view/adsPreview/container';
import topTemplate from '@bingads-webui-campaign-legacy/crud-ad/template/adsPreview/top.pug';
import sidebarTemplate from '@bingads-webui-campaign-legacy/crud-ad/template/adsPreview/sidebar.pug';
import mobileTemplate from '@bingads-webui-campaign-legacy/crud-ad/template/adsPreview/mobile.pug';
import PreviewViewModel from '@bingads-webui-campaign-legacy/crud-ad/viewmodel/adsPreview/dynamicSearchAd';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

export default function buildPreview(adViewModel, placeholders) {
  let viewModel = new PreviewViewModel(adViewModel, placeholders);
  let adType = 'DynamicSearchAd';

  return new PreviewContainer({
    tabs: [{
      top: {
        template: topTemplate,
        viewModel,
        title: i18n.get('Ad_TopView'),
        adType,
      },
      sidebar: {
        template: sidebarTemplate,
        viewModel,
        title: i18n.get('Ad_SideView'),
        adType,
      },
      mobile: {
        template: mobileTemplate,
        viewModel,
        title: i18n.get('Ad_MobileView'),
        adType,
      },
    }],
  });
}
